// export {default} from './VolumePerformanceReport';
import {SCREEN_NAMES} from '/enum/tealium.enum';
import {withScreenPersistence} from '/util/async-storage';

import VolumePerformanceReport from './VolumePerformanceReport';

export default withScreenPersistence(
  VolumePerformanceReport,
  SCREEN_NAMES.volumePerformanceReport,
);
